import { Navigate } from 'react-router-dom';
import { useState } from 'react';
import KitchenHeader from '../header/KitchenHeader';
import methods from '../../services/utility';

const KitchenLayout = ({ component: Component, ...rest }) => {
    const isUserLogedin = methods.checkUserLogin();
    return (
        <div className='container-fluid'>
            {isUserLogedin ?
                <>
                    <KitchenHeader />
                    <div className='row'>
                        <div className={`col-lg-12 mt-3 mx-auto`}>
                            <Component {...rest} />
                        </div>
                    </div>
                </>
                :
                <Navigate to="/login" />
            }
        </div>
    )
};

export default KitchenLayout;